
import {Component, Vue} from 'vue-property-decorator';
import {readUploadProgress} from '@/store/main/getters';
import {commitCancelUploadProgress, commitClearUploadProgress} from '@/store/main/mutations';

@Component
export default class UploadProgressDialog extends Vue {
  get progress() {
    return readUploadProgress(this.$store);
  }

  get show() {
    return Boolean(this.progress?.active);
  }

  get percent() {
    if (!this.progress?.total) {
      return 0;
    }
    return Math.round((this.progress.current / this.progress.total) * 100);
  }

  public cancel() {
    commitCancelUploadProgress(this.$store);
  }

  public close() {
    commitClearUploadProgress(this.$store);
  }
}
